import { useMutation, useQueryClient } from 'react-query';
import userApi from '@/util/userApi';
import { useCurrentUserContext } from '@shared/hooks/useCurrentUserContext';
import { APPLICATION_TYPE } from '@shared/constants';

type UserUpdates = {
  hideHelpCenter?: boolean;
  shownGetStarted?: boolean;
  userAppType?: APPLICATION_TYPE;
  visualizationType?: string;
};

export const useUpdateUserSettingsMutation = () => {
  const { user: currentUser } = useCurrentUserContext();
  const username = currentUser?.username;
  const queryClient = useQueryClient();

  return useMutation(
    ({ updates }: { updates: UserUpdates }) =>
      userApi.updateUserSettings({ updates, username }),
    {
      onMutate: async () => {
        await queryClient.cancelQueries(['current-user']);
      },
      onSettled: async () => {
        await queryClient.invalidateQueries(['current-user']);
      }
    }
  );
};
